/* Casa Blu landing · Dash Grip 360 (lp-dgp). Small, data-driven interactions; no globals, no network calls.
 * The COD buttons never re-implement the form: they click the Releasit button the app already placed
 * in the product form, or scroll to the product form when that button is not present. */
(() => {
  // each lp-dgp section links this file; run once per page
  if (document.documentElement.dataset.lpDgpJs) return;
  document.documentElement.dataset.lpDgpJs = '1';
  const press = (els, on) => els.forEach(x => x.setAttribute('aria-pressed', String(x === on)));

  const init = {
    anatomia(root) {
      const hots = [...root.querySelectorAll('.lp-hot')], parts = [...root.querySelectorAll('.lp-part')];
      const set = n => {
        hots.forEach(h => h.setAttribute('aria-pressed', String(h.dataset.part === n)));
        parts.forEach(p => { p.dataset.active = String(p.dataset.part === n); });
      };
      [...hots, ...parts].forEach(el => el.addEventListener('click', () => set(el.dataset.part)));
    },
    giro(root) {
      const frame = root.querySelector('.lp-orient-frame'), cap = root.querySelector('.lp-orient-cap');
      const btns = [...root.querySelectorAll('.lp-seg button')];
      btns.forEach(b => b.addEventListener('click', () => {
        frame.dataset.mode = b.dataset.mode;
        cap.textContent = b.dataset.cap || '';
        press(btns, b);
      }));
    },
    encaja(root) {
      const res = root.querySelector('.lp-fit-result'), msg = root.querySelector('.lp-fit-msg');
      const groups = [...root.querySelectorAll('.lp-yn')];
      groups.forEach(g => {
        const btns = [...g.querySelectorAll('button')];
        btns.forEach(b => b.addEventListener('click', () => {
          press(btns, b);
          const vals = groups.map(gg => { const p = gg.querySelector('[aria-pressed="true"]'); return p ? p.dataset.v : null; });
          if (vals.includes('0')) { res.dataset.state = 'no'; msg.textContent = res.dataset.msgNo; }
          else if (vals.every(v => v === '1')) { res.dataset.state = 'yes'; msg.textContent = res.dataset.msgYes; }
          else { res.dataset.state = 'idle'; msg.textContent = res.dataset.msgIdle; }
        }));
      });
    }
  };

  // COD trigger: reuse the app's own button; fall back to the product form.
  const openCod = () => {
    // only the app's button inside the theme's product form; never the floating bar, never anything inside the app modal (its submit shares the class)
    const appBtn = [...document.querySelectorAll('product-form ._rsi-buy-now-button, .product-form ._rsi-buy-now-button')]
      .find(b => !b.classList.contains('_rsi-modal-submit-button') && !b.closest('.lp-dgp, ._rsi-buy-now-button-floating, ._rsi-build-block, [class*="_rsi-modal"], [class*="_rsi-cod-form-modal"]') && b.offsetParent !== null);
    if (appBtn) { appBtn.click(); return; }
    const form = document.querySelector('product-form, .product-form');
    if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const boot = scope => {
    scope.querySelectorAll('[data-lp-dgp]').forEach(root => {
      if (root.dataset.lpReady) return;
      root.dataset.lpReady = '1';
      const fn = init[root.dataset.lpDgp];
      if (fn) fn(root);
    });
  };

  document.addEventListener('click', e => {
    const b = e.target.closest('[data-lp-cod]');
    if (!b) return;
    e.preventDefault();
    openCod();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
